module.exports = __webpack_public_path__ + "static/media/software.29f93447.png";